export const buildRoleSet = (context)=>{
    const { user: { roles } } = context;
    const roleSet = [];
    (roles ?? []).forEach((role)=>{
        return role.roles.forEach((r)=>{
            if (context.activeContext?.tenantId === role.tenantId) roleSet.push(r.roleName);
        });
    });
    return roleSet;
};
